// extracted by mini-css-extract-plugin
module.exports = {"turboSpinnerLoader":"_1hH5R","rotate":"_3C9pm","loading":"_2_kjd"};